module.exports = __webpack_public_path__ + "img/圆环1.8a3dbb8f.png";